import { IDefaultConfig, IExperimentConfig, IFeatureFlagConfig } from '../../interfaces/init-chatbot-interfaces';
import { API_ENDPOINTS } from '../../config/api-config';
import { getChatbotToken } from '../session-storage-utils';
import { getChatbotSessionInfo } from '../chatbot/api-utils';

export const isPageChatbotEnabled = (pageName?: string) => {
  console.log('Checking if page chatbot is enabled for page:', pageName);
  if (typeof window === 'undefined' || !window.location) {
    console.warn('isPageChatbotEnabled can only be called in a browser environment with a valid window.location.');
    return false;
  }
  const pageURL = window.location.href;
  if ((pageURL && pageURL.includes('localhost')) || pageURL.includes('staging')) return true;
  /** Enabled for any pageName that exist in array */
  // if (pageName && chatbotEnabledPages.includes(pageName?.toLowerCase())) return true;
  /** Explicitly Enabled for help center page */
  if (pageURL && pageURL.includes('/customer-care/')) return true;
  return false;
};

export const getInitChatbotConfig = async (locale: string): Promise<IFeatureFlagConfig | IExperimentConfig | IDefaultConfig> => {
  const response = await fetch(API_ENDPOINTS.CHATBOT_CONFIG);
  if (!response.ok) {
    throw new Error('Failed to chatbot config');
  }
  const config = await response.json();

  if (config[locale]) return config[locale];

  return {
    deploymentType: 'disabled',
    disableChatbot: true,
    chatbotEnabledPages: [],
    enableChatbotOnAllPages: false,
  };
};

export const isSessionOlderThan24Hours = (): boolean => {
  const token = getChatbotToken();
  if (!token) return false;
  const sessionInfo = getChatbotSessionInfo(token);

  if (!sessionInfo.exp) return false;

  const currentTime = new Date().getTime();
  const expiryTime = new Date(sessionInfo.exp).getTime();
  const twentyFourHoursInMs = 24 * 60 * 60 * 1000;

  return currentTime - expiryTime > twentyFourHoursInMs;
};
